// Constants to be used as content for the associated component's `console.error` or `console.warn`.
export const MESSAGES = {
    EMPTY_CHILDREN: 'Button cannot have an empty string for children.',
};
